import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  modelConfigId	: number;
  modelConfigCode:string;
  virtualListUnfoldCacheId: number;
  overviewCacheData: any;
  labelsCacheData: any[];
}

const initialState: InitStata = {
  modelConfigId: -1,
  modelConfigCode: '',
  virtualListUnfoldCacheId: 0, // 缓存虚拟列表展开项的id
  labelsCacheData: [], // 缓存虚拟列表展开项relations接口数据，避免因为组件render造成的闪动
  overviewCacheData: null, // 缓存虚拟列表展开项overview接口数据，避免因为组件render造成的闪动
};

const customerSlice = createSlice({
  name: 'iterate',
  initialState,
  reducers: {
    changeCurModelId: (state = initialState, action: PayloadAction<number>) => {
      state.modelConfigId	 = action.payload;
    },
    changeCurModelCode: (state = initialState, action: PayloadAction<string>) => {
      state.modelConfigCode	 = action.payload;
    },
    setVirtualListUnfoldCacheId: (state = initialState, action: PayloadAction<number>) => {
      state.virtualListUnfoldCacheId = action.payload;
    },
    setLabelsCacheData: (state = initialState, action: PayloadAction<any[]>) => {
      state.labelsCacheData	 = action.payload;
    },
    setOverviewCacheData: (state = initialState, action: PayloadAction<any>) => {
      state.overviewCacheData	 = action.payload;
    },
    clearCacheData: (state = initialState) => {
      state.labelsCacheData	 = [];
      state.overviewCacheData	 = null;
    },
  },
});

// 导出action
export const {
  changeCurModelId,
  changeCurModelCode,
  setVirtualListUnfoldCacheId,
  setLabelsCacheData,
  setOverviewCacheData,
  clearCacheData,
} = customerSlice.actions;

export default customerSlice.reducer;
